import { useEffect, useState } from 'react';

const check = (): boolean => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

export const useIframed = (): boolean => {
    const [iframed, setIframed] = useState(check());

    useEffect(() => {
        setIframed(check());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window?.self, window?.top]);

    return iframed;
};
